import { getSubmissionGradeSnapshot } from 'utils/gradePushback';
import { getSubmissionSections } from 'utils/gradingNavigation';
import { filterSubmissions, SubmissionFilter } from 'utils/submissionFilters';

export const QuizSubmissionStatus = Object.freeze({
    READY: SubmissionFilter.READY,
    REVIEWED: SubmissionFilter.REVIEWED,
    IN_PROGRESS: 'in_progress',
    FAILED: 'failed',
    PROCESSING: 'processing',
});

export const getQuizSubmissionStatus = (submission) => {
    if (submission.grading_status === 'in_progress') return QuizSubmissionStatus.IN_PROGRESS;
    if (submission.grading && (!submission.grading_status || submission.grading_status === 'confirmed')) {
        return QuizSubmissionStatus.REVIEWED;
    }
    if (submission.ai) return QuizSubmissionStatus.READY;
    if (submission.is_failed) return QuizSubmissionStatus.FAILED;
    return QuizSubmissionStatus.PROCESSING;
};

export const getQuizSubmissionSection = (submission) =>
    getSubmissionSections(submission)
        .map(({ name }) => name)
        .join(', ') || '--';

export const getQuizSubmissionGradeSnapshot = (submission, quiz) =>
    getQuizSubmissionStatus(submission) === QuizSubmissionStatus.REVIEWED
        ? getSubmissionGradeSnapshot(submission, quiz)
        : null;

export const getViewableQuizSubmissions = (submissions = []) =>
    submissions
        .filter((submission) => getQuizSubmissionStatus(submission) === QuizSubmissionStatus.REVIEWED)
        .sort((a, b) =>
            String(a.api?.user?.name || a.api?.user?.id || a.id).localeCompare(
                String(b.api?.user?.name || b.api?.user?.id || b.id),
                undefined,
                { numeric: true, sensitivity: 'base' }
            )
        );

export const filterQuizSubmissions = (submissions, filters, quiz) => {
    const status = filters.status || [];
    // Share search and LMS filters, using confirmed grades rather than unfinished drafts.
    const normalized = submissions.map((submission) =>
        getQuizSubmissionStatus(submission) === QuizSubmissionStatus.REVIEWED
            ? submission
            : { ...submission, grading: null }
    );
    const matchingIds = new Set(filterSubmissions(normalized, { ...filters, status: [] }, quiz).map(({ id }) => id));
    return submissions.filter(
        (submission) =>
            matchingIds.has(submission.id) && (!status.length || status.includes(getQuizSubmissionStatus(submission)))
    );
};
